import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { MetricResult, QueryMetricsResponse, ResourceMetricResult } from '@vendasta/multi-location-analytics';
import { map } from 'rxjs/operators';

const rounderPipe = new DecimalPipe(`en-US`);

// round uses an angular decimal pipe for consistent rounding logic
export function round(value: number, pipeOpts: string): number | null {
  const val = rounderPipe.transform(value, pipeOpts);
  return val === null ? null : +val.replace(',', '');
}

export class Row {
  constructor(
    public values: any[],
    public measures: any[],
  ) {}
}

export function rowify(r: ResourceMetricResult): Row[] {
  if (!r.metrics || !r.metrics.metrics) {
    return [];
  }
  const res = r.metrics.metrics.map(function (m: MetricResult): Row[] {
    return parse(m, new Row([], []));
  });
  const rows = [];
  res.forEach((singleDayMeasureValues) => {
    rows.push(singleDayMeasureValues[0]);
  });
  return rows;
}

function parse(m: MetricResult, r: Row): Row[] {
  r.values.push(m.dimension);
  if (!m.results || !m.results.metrics) {
    r.measures.push(m.measures);
    return [r];
  }
  const all = m.results.metrics.map(function (val: MetricResult): Row[] {
    return parse(val, r);
  });
  return all.reduce((acc, val) => acc.concat(val), []);
}

export class QueryMetricsResponseDelta {
  readonly currentPeriodRows$: Observable<Row[]>;
  readonly previousPeriodRows$: Observable<Row[]>;
  constructor(
    public currentPeriod$: Observable<QueryMetricsResponse>,
    public prevPeriod$: Observable<QueryMetricsResponse>,
  ) {
    this.currentPeriodRows$ = this.currentPeriod$.pipe(
      map((r) => {
        if (!r) {
          return null;
        }
        return rowify(r.metricResults[0]);
      }),
    );
    this.previousPeriodRows$ = this.prevPeriod$.pipe(
      map((r) => {
        if (!r) {
          return null;
        }
        return rowify(r.metricResults[0]);
      }),
    );
  }
}
